// Vendor Libs
import {Component} from 'react';
import PropTypes from 'prop-types';

export default class PanelAction extends Component {
    state = {
        registeredId: null,
        showPanel: this.props.showPanel,
    };

    UNSAFE_componentWillMount() {
        this.setState({
            registeredId: this.context.registerPanelAction(this.getPanelActionParams()),
        });
    }

    UNSAFE_componentWillUpdate(nextProps) {
        if (nextProps.showPanel && !this.state.showPanel) {
            this.setState({showPanel: true});
        }
    }

    componentWillUnmount() {
        this.context.unregisterPanelAction(this.state.registeredId);
    }

    handlePanelActionClick = event => {
        this.setState({showPanel: !this.state.showPanel});
        this.props.onClick(event);
    };

    getPanelActionParams() {
        const {groupByIcon, contentRenderer, hotkey, icon, title, weight} = this.props;

        return {
            groupByIcon,
            hotkey,
            icon,
            onClick: this.handlePanelActionClick,
            renderCallback: contentRenderer,
            title,
            weight,
        };
    }

    render() {
        return this.state.showPanel && this.props.contentRenderer ? this.props.contentRenderer() : null;
    }
}

PanelAction.contextTypes = {
    registerPanelAction: PropTypes.func.isRequired,
    unregisterPanelAction: PropTypes.func.isRequired,
};

PanelAction.propTypes = {
    contentRenderer: PropTypes.func,
    groupByIcon: PropTypes.bool,
    hotkey: PropTypes.string,
    icon: PropTypes.string,
    onClick: PropTypes.func,
    onToggle: PropTypes.func,
    showPanel: PropTypes.bool,
    title: PropTypes.string,
    weight: PropTypes.number,
};

PanelAction.defaultProps = {
    icon: 'search',
    onClick: () => undefined,
    showPanel: false,
};
